export const initialState = {
    newsList: [],
    newsSetting: null,
    announcementList: [],
    announcementDetails: [],
};

const state = { ...initialState };

export default state;